import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { HeadingWidgetComponent } from "src/app/shared/components/heading-widget/heading-widget.component";
import { MobileComponent } from "src/app/shared/components/mobile/interface/mobile.component";
import { ReadMoreComponent } from "src/app/shared/components/read-more/read-more.component";
import { I18nPipe } from "src/app/shared/i18n/pipe/i18n.pipe";
import { MaterialModule } from "src/app/shared/module/material.module";
import { InformativeNote } from "../model/informative-note.model";

// Dialog che rende una singola nota informativa (testo HTML) del CMS.
// Le note vengono aperte in sequenza da InformativeNotesService.
@Component({
  selector: "ald-informative-note",
  templateUrl: "./informative-note.component.html",
  styleUrls: ["./informative-note.component.scss"],
  standalone: true,
  imports: [HeadingWidgetComponent, MaterialModule, ReadMoreComponent, I18nPipe],
})
export class InformativeNoteComponent extends MobileComponent {
  constructor(
    public dialogRef: MatDialogRef<InformativeNoteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InformativeNote
  ) {
    super();
  }

  onClose(): void {
    this.dialogRef.close(true);
  }
}
